import { useState } from "react";
import { mirrorSites, statusFilter } from "@/mocks/mirrorData";

const statusStyles: Record<string, string> = {
  stable: "bg-primary-100 text-primary-700",
  new: "bg-accent-100 text-accent-800",
  backup: "bg-secondary-100 text-secondary-900",
  maintenance: "bg-foreground-100 text-foreground-600",
};

export default function MirrorList() {
  const [active, setActive] = useState("all");
  const [copiedId, setCopiedId] = useState<string | null>(null);

  const filtered =
    active === "all" ? mirrorSites : mirrorSites.filter((s) => s.status === active);

  const copy = async (domain: string, id: string) => {
    try {
      await navigator.clipboard.writeText(domain);
    } catch {
      /* ignore clipboard errors */
    }
    setCopiedId(id);
    window.setTimeout(() => setCopiedId(null), 1600);
  };

  return (
    <section id="addresses" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm text-secondary-900">
            <i className="ri-route-line" /> 实时入口列表
          </span>
          <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">当前可用入口</h2>
          <p className="mt-4 text-base leading-7 text-foreground-600">
            以下入口与主站实时同步，任选一个均可继续浏览。状态实时更新，若某入口繁忙，请优先使用标注“正常”或“新上线”的地址。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center gap-2">
          {statusFilter.map((f) => (
            <button
              key={f.key}
              type="button"
              onClick={() => setActive(f.key)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition ${
                active === f.key
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {filtered.map((s) => (
            <div
              key={s.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-5"
            >
              <div className="flex items-center justify-between">
                <span
                  className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs ${statusStyles[s.status]}`}
                >
                  <span className="h-1.5 w-1.5 rounded-full bg-current" />
                  {s.statusText}
                </span>
                <span className="text-xs text-foreground-500">{s.region}</span>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{s.name}</h3>
              <p className="mt-1 break-all font-mono text-sm text-primary-600">{s.domain}</p>
              <p className="mt-3 flex-1 text-sm leading-6 text-foreground-600">{s.description}</p>
              <div className="mt-5 flex items-center gap-2">
                <a
                  href={`https://${s.domain}`}
                  rel="nofollow"
                  target="_blank"
                  className="flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2 text-sm font-medium text-background-50 transition hover:bg-primary-600"
                >
                  <i className="ri-external-link-line" /> 前往入口
                </a>
                <button
                  type="button"
                  onClick={() => copy(s.domain, s.id)}
                  aria-label="复制地址"
                  className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={copiedId === s.id ? "ri-check-line text-primary-600" : "ri-file-copy-line"} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <p className="mt-6 text-sm text-foreground-500">
          提示：请优先使用标注“正常”的入口；复制地址后可直接粘贴到浏览器地址栏打开。
        </p>
      </div>
    </section>
  );
}